import { useMemo } from 'react'
import { FolderDown, FileText, Link2, ExternalLink } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import { useCollection } from '../../hooks/useFirestore'
import { formatFileSize } from '../../utils/helpers'
import { Badge, Card } from '../../components/common'

const WorkersResources = () => {
  const { userProfile } = useAuth()
  const myDepartments = userProfile?.departmentIds || []

  const { data: resources, loading } = useCollection('resources')
  const { data: departments } = useCollection('departments', {
    orderByField: 'order',
    orderDirection: 'asc',
  })

  const deptName = (slug) => departments?.find((d) => d.id === slug)?.name || slug

  const visible = useMemo(
    () =>
      (resources || []).filter((r) => {
        const targets = r.departmentIds || []
        return targets.length === 0 || targets.some((slug) => myDepartments.includes(slug))
      }),
    [resources, myDepartments]
  )

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-dark-100">Resources</h1>
        <p className="text-gray-500">Documents and links shared with you</p>
      </div>

      <div className="space-y-2">
        {visible.map((r) => (
          <a
            key={r.id}
            href={r.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-xl shadow-soft p-4 flex items-center gap-3 hover:shadow-lg transition-shadow"
          >
            <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
              {r.type === 'link'
                ? <Link2 className="w-5 h-5 text-primary-600" />
                : <FileText className="w-5 h-5 text-primary-600" />}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <p className="font-medium text-dark-100">{r.title}</p>
                {(r.departmentIds || []).map((slug) => (
                  <Badge key={slug} variant="primary" size="sm">{deptName(slug)}</Badge>
                ))}
              </div>
              {r.description && <p className="text-sm text-gray-500">{r.description}</p>}
              {r.fileSize && (
                <p className="text-xs text-gray-400">{formatFileSize(r.fileSize)}</p>
              )}
            </div>
            <ExternalLink className="w-4 h-4 text-gray-400 flex-shrink-0" />
          </a>
        ))}

        {!loading && visible.length === 0 && (
          <Card className="text-center py-12 text-gray-500">
            <FolderDown className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>No resources shared yet</p>
          </Card>
        )}
      </div>
    </div>
  )
}

export default WorkersResources
